import { DropDownItemProps, DropDownItemValueProps } from 'spindl-shared-components';
import { MediaUploadType } from '../modules/assets/types';
import { EntryValueType } from '../modules/entries/types';
import { FieldSchema, FieldTypes } from '../modules/tables/types';

export type UnderlineStyleEnum = 'Blue' | 'Green' | 'Orange' | 'Purple' | 'Red';

export type DropDownItemCombinedProps = DropDownItemProps & DropDownItemValueProps;

// Cell UI state types
export type CellStateEnum = 'CellFirstSelect' | 'CellSecondSelect' | 'Default' | 'Disabled' | 'Error' | 'Expanded' | 'Highlighted';
export type ModalFieldStateEnum = 'Default' | 'Error' | 'Expanded' | 'FirstSelect' | 'FirstSelectExpanded' | 'SecondSelect';

export type MainCellProps = {
  state?: CellStateEnum;
  handleFocus?: (event?: React.FocusEvent<HTMLDivElement | HTMLTextAreaElement>) => void;
  updateCellState?: (cellState: CellStateEnum) => void;
} & CellStateProps;

export type MainModalFieldProps = {
  state?: ModalFieldStateEnum;
  updateModalFieldState?: (fieldState: ModalFieldStateEnum) => void;
} & CellStateProps;

export type CellStateProps = {
  dataType?: FieldTypes;
  invalid?: string;
  value?: EntryValueType;
  getCellSchema?: () => CellSchema;
  getReferenceOptionsData?: () => ReferenceOptionsData;
  handleBlur?: (event?: React.FocusEvent<HTMLDivElement | HTMLTextAreaElement>) => void;
  handleClick?: (event?: React.MouseEvent<HTMLDivElement>) => void;
  handleDoubleClick?: (event?: React.MouseEvent<HTMLDivElement>) => void;
  handleKeyDown?: (event?: React.KeyboardEvent<HTMLDivElement | HTMLTextAreaElement>) => void;
  updateCellValue?: (databaseSlug: string, tableSlug: string, cellValue: EntryValueType) => Promise<void>;
  uploadAsset?: (databaseSlug: string, tableSlug: string, file: File, assetType: MediaUploadType) => Promise<void>;
};

export type CellSchema = {
  fieldName: string;
  fieldSchema: FieldSchema | undefined;
};

export type ReferenceOptionsData = {
  referenceFieldNames: string[];
};

export type KeyDownOptions = {
  key: string;
  shift?: boolean;
  ctrl?: boolean;
  alt?: boolean;
};

export type TextPreprocessor = (
  ref: React.RefObject<HTMLTextAreaElement>,
  event: React.ChangeEvent<HTMLTextAreaElement>,
) => void;

export const enum BooleanOptions {
  True = 'True',
  False = 'False',
}

// "True" | "False"
export type BooleanOption = keyof typeof BooleanOptions;

export type DropDownOption = {
  text?: string;
  value?: string;
};
